import { useSelector } from 'react-redux';
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { NewHireProps } from '../../../models/arc-epi-props';
import { WhoWillEnrollContentModel } from '../models/who-will-enroll-models';

export function useNewHireWhoWillEnrollContentModel(): WhoWillEnrollContentModel {
    const settings = useSelector<TcsmStates, NewHireProps>(state => state.epiProps?.newHireSettingsState?.epiContent);

    return {
        ...settings,
        gpsType: GpsType.NEW_HIRE_WHO_WILL_ENROLL,
    };
}